import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';
import { ServiceActivity } from '../../../../core/models/serviceactivity.interface';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceactivityService } from '../../../../core/services/serviceactivity/serviceactivity-service';
import { MatDialog } from '@angular/material/dialog';
import { LoadingService } from '../../../../core/services/loading/loading';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { ServiceactivityForm } from '../serviceactivity-form/serviceactivity-form';
import { TermPipe } from '../../../../shared/pipes/term.pipe';
import { TermKey } from '../../../../core/models/terminology.interface';

@Component({
  selector: 'app-serviceactivity-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search,
    TermPipe,
  ],
  templateUrl: './serviceactivity-list.html',
  styleUrl: './serviceactivity-list.scss',
})
export class ServiceactivityList {
  public page = 1;
  total: number = 0;
  limit: number = 10;
  private sectorName: string | null = null;
  serviceactivity: ServiceActivity[] = [];
  asyncserviceactivity!: Observable<ServiceActivity[]>;
  buscarserviceactivity: string = '';
  termKey = TermKey;
  @Input() filtro: string = '';
  @Input() orden: string = '';
  showColumns: string[] = [
    'acciones',
    'id',
    'name',
    'description',
    'month',
    'consumableAssets',
    'locations',
    'adress',
    'line',
    'total',
  ];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private serviceactivityService: ServiceactivityService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Actividades del servicio');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchServiceActivities(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();

    this.layoutService.sectorSelected$.subscribe((sector) => {
      this.sectorName = sector?.name ?? null;
      this.fetchServiceActivities(1);
    });
  }

  fetchServiceActivities(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    const sectorName = this.layoutService.getSectorSelected()?.name;
    if (sectorName) {
      params.filters.push({ name: 'sector', value: sectorName } as Filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncserviceactivity = this.serviceactivityService.getServiceActivity(params).pipe(
      tap((data) => {
        this.serviceactivity = data.results;
        this.serviceactivityService.setServiceActivity(data.results[0]);
        this.serviceactivityService.setServiceActivities(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createServiceActivity() {
    this.serviceactivityService.removeServiceActivitySelected();
    const dialogRef = this.dialog.open(ServiceactivityForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
      data: { fromList: true },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchServiceActivities(this.page);
    });
  }

  updateServiceActivity(serviceActivity: ServiceActivity) {
    this.serviceactivityService.setServiceActivity(serviceActivity);
    const dialogRef = this.dialog.open(ServiceactivityForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
      data: { fromList: true },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchServiceActivities(this.page);
    });
  }

  eliminate(serviceActivity: ServiceActivity): void {
    const confirmed = window.confirm(
      `¿Estás seguro de eliminar el registro: ${serviceActivity.name}?`,
    );
    if (!confirmed) return;
    this.serviceactivityService.delete(serviceActivity.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchServiceActivities(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
